/**
 * @import { ItineraryDay } from '@/features/itinerary-map/types/itinerary-day'
 */

import { usePortInfoContext } from '@/features/itinerary-map/context/port-info';
import { formatPortName } from '@/features/itinerary-map/utils/cruise';
import { PortMarker } from './port-marker';

/**
 * @param {object} props
 * @param {ItineraryDay[]} [props.days]
 * @param {(day: ItineraryDay, marker: google.maps.marker.AdvancedMarkerElement) => void} props.onPortClick
 * @returns {React.JSX.Element}
 */
export function PortsLayer({ days, onPortClick }) {
  const { portInfo } = usePortInfoContext();
  const selectedDayNumber = portInfo?.days[portInfo.selectedDayIndex]?.dayNumber;

  return (
    <>
      {days?.map((day, index) => {
        const ariaLabel = `Day ${day.dayNumber}: ${formatPortName(day.port)}`;
        return (
          <PortMarker
            ariaLabel={ariaLabel}
            key={index}
            port={day.port}
            isStart={index === 0}
            isCurrent={day.dayNumber === selectedDayNumber}
            isOvernight={day.port.overnight}
            onClick={(marker) => onPortClick(day, marker)}
          />
        );
      })}
    </>
  );
}
